export default __webpack_public_path__ + "static/media/advantage-icon4.7cf5ded8.svg";